<template lang="pug">
  .chart-wrap
    slot
    el-button.export-pdf-btn(@click='doExport' size='mini' icon='document')

</template>

<script>
import ChartMixin from "@/shared/mixins/Chart";

export default {
  mixins: [ChartMixin],
  methods: {
    doExport() {
      const canvas = this.$children[0].$refs.canvas;
      this.toPdf(canvas);
    }
  }
};
</script>

<style scoped lang="scss">
.chart-wrap {
  position: relative;

  &:hover {
    .export-pdf-btn {
      opacity: 1;
    }
  }
}

.export-pdf-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 8px;
  color: #666;
  border-radius: 3px;
  display: flex;
  align-items: center;
  vertical-align: center;
  height: 24px;
  opacity: 0;
  cursor: pointer;
  transition: opacity 200ms ease-in;

  i {
    font-size: 14px;
  }
}
</style>
